import React, { Fragment, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import MyCard from "../../../tools/MyCard";

import {
  BanknoteArrowDown,
  Braces,
  ChartNoAxesCombined,
  Check,
  CircleCheckBig,
  Clock4,
  Code,
  Coins,
  Copy,
  Eye,
  Flame,
  Gift,
  GitCommitVertical,
  Handbag,
  Landmark,
  Link,
  LogIn,
  LogOut,
  Mail,
  MapPinned,
  MousePointer2Off,
  MousePointerClick,
  Pause,
  Phone,
  RefreshCw,
  Snowflake,
  SquareArrowOutUpRight,
  Trash2,
  User,
  UserMinus,
  UserRoundPlus,
  Users,
  UserStar,
  UserX,
  Wallet,
} from "lucide-react";
import MyCard2 from "../../../tools/MyCard2";
import MyCard3 from "../../../tools/MyCard3";
import { MyColors } from "../../../util/my_colors";
import MyButton from "../../../tools/MyButton";
import {
  AndroidLogo,
  CreditCard,
  DeviceMobileSpeaker,
  GlobeStand,
  GoogleLogo,
  LinkedinLogo,
  TelegramLogo,
} from "phosphor-react";
import MyCard4 from "../../../tools/MyCard4";
import { CableOutlined } from "@mui/icons-material";
import { userData } from "../../../../data/userData";
import { MyModal } from "../../../global/MyModal";
import { useNavigate, useParams } from "react-router-dom";
import {
  crediBonusAmount,
  deleteSingleUser,
  getAppUserDetails,
  updateBlockUser,
  updateLogInUser,
  updateLogoutUser,
  updateUnBlockUser,
  updateUserPayout,
} from "../api";
import MyLoader from "../../../util/MyLoader";
import MyCard7 from "../../../tools/MyCard7";
import { SolidButton } from "../../../global/SolidButton";
import { BorderButton } from "../../../global/BorderButton";
import { copyToClipboard } from "../../../util/UtilFunctions";
import MyTooltip from "../../../tools/MyTooltip";

export default function Profile() {
  // const data = userData.user;
  const [modalOpen, setModalOpen] = useState(false);
  const [invitesCutting, setInvitesCutting] = useState(0);
  const [inviteRed, setInviteRed] = useState(0);
  const { user_id, id } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [isSignIn, setIsSign] = useState(true);
  const [isBlock, setIsBlock] = useState(false);
  const [isOpenCreditModal, setOpenCreditModal] = useState(false);
  const [isOpenDebitModal, setOpenDebitModal] = useState(false);
  const [bonusCoins, setBonusCoins] = useState(null);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [isFreezed, setFreeze] = useState(false);
  const [isViewPhoto, setIsViewPhoto] = useState(false);
  const [photo, setPhoto] = useState(null);
  const [deleteUserId, setUserDeleteId] = useState(null);

  const navigate = useNavigate();

  const openReductionEdit = () => {
    setInviteRed(Number(invitesCutting || 0));
    setModalOpen(true);
  };

  const saveReduction = () => {
    // persist locally for now; in future hook into API
    const val = Number(inviteRed);
    if (!Number.isFinite(val) || isNaN(val) || val < 0) {
      toast.error("Reduction must be a number ≥ 0");
      return;
    }

    setInvitesCutting(val);
    // update the shared userData so other components/readers see the change
    try {
      userData.user.invites_cutting = String(val);
    } catch (e) {
      // ignore if userData not writable
      console.error("error: ", e);
    }
    setModalOpen(false);
    toast.success("Invite reduction updated");
    console.log("Saved reduction:", val);
  };

  const amtOptions = [100, 200, 500, 1000, 1500, 2000, 3000];
  const fetchUserDetails = async () => {
    try {
      const res = await getAppUserDetails(user_id);
      if (res?.status === 200) {
        const data_f = res?.data.user;

        setData(data_f || {});
        setInvitesCutting(data_f.invites_cutting);
        const status = data_f.status;
        status === "active"
          ? setIsSign(true)
          : status === "inactive"
            ? setIsSign(false)
            : status === "blocked"
              ? setIsBlock(true)
              : setIsBlock(false);

        // if (status === "block" || status === "active") {
        //   setIsSign(false);
        // }
        setFreeze(data_f.redeem_enabled === "1");
      }
    } catch (err) {
      console.err("failed to fetch user data :", err);
    } finally {
      setLoading(false);
    }
  };
  const signOut = async () => {
    try {
      const res = await updateLogoutUser(user_id);
      if (res?.status === 200) {
        toast.success("Logout user successfully");

        setIsSign(false);
      }
    } catch (err) {
      console.error("failed to update for logout:", err);
    } finally {
      setLoading(false);
    }
  };
  const signIn = async () => {
    try {
      const res = await updateLogInUser(user_id);
      if (res?.status === 200) {
        toast.success("Signin user successfully");
        console.log("res of login", res);
        setIsSign(true);
      }
    } catch (err) {
      console.error("failed to update for logout:", err);
    } finally {
      setLoading(false);
    }
  };

  const block = async () => {
    try {
      const res = await updateBlockUser(user_id);
      if (res?.status === 200) {
        toast.success("Blocked successfully");
        setIsBlock(true);
      }
    } catch (err) {
      console.error("failed to update for logout:", err);
    } finally {
      setLoading(false);
    }
  };
  const unblock = async () => {
    try {
      const res = await updateUnBlockUser(user_id);
      if (res?.status === 200) {
        toast.success("unblocked successfully");
        setIsBlock(false);
      }
    } catch (err) {
      console.error("failed to update for logout:", err);
    } finally {
      setLoading(false);
    }
  };

  // credit bonus
  const creditBonus = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const errs = {};
    //bonus coins validation
    if (bonusCoins === null || bonusCoins < 1) {
      errs.bonusCoins = "Amount is required";
    }
    //message validation'
    if (!message || message === null) {
      errs.message = "Message is required";
    }

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    try {
      const payload = {
        coins: bonusCoins,
        message: message,
      };
      const res = await crediBonusAmount(user_id, payload);
      if (res?.status === 200) {
        toast.success(res?.data.message);
        setBonusCoins(null);
        setMessage("");
        setErrors({});
        fetchUserDetails();
        setOpenCreditModal(false);
      }
    } catch (err) {
      console.error("failed to credit bonus :", err);
    }
  };
  // ddebit bonus
  const debitBonus = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const errs = {};
    //bonus coins validation
    if (bonusCoins === null || bonusCoins > 1) {
      errs.bonusCoins = "Amount is required";
    }
    //message validation'
    if (!message || message === null) {
      errs.message = "Message is required";
    }

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    try {
      const payload = {
        coins: bonusCoins,
        message: message,
      };
      const res = await crediBonusAmount(user_id, payload);
      if (res?.status === 200) {
        toast.success(res?.data.message);
        setBonusCoins(null);
        setMessage("");
        setErrors({});
        fetchUserDetails();
        setOpenDebitModal(false);
      }
    } catch (err) {
      console.error("failed to credit bonus :", err);
    }
  };

  const freezeUserPayout = async (isFreeze) => {
    try {
      const payload = {
        redeem_enabled: isFreeze ? "1" : "0",
      };
      const res = await updateUserPayout(user_id, payload);
      if (res?.status === 200) {
        setFreeze(isFreeze);
        toast.success(`payouts ${isFreeze ? "Freezed" : "Unfreeze"}`);
      }
    } catch (err) {
      console.error("failed to update user payout :", err);
    }
  };

  const deleteUser = async () => {
    try {
      const res = await deleteSingleUser(user_id);
      if (res?.status == 200) {
        setUserDeleteId(null);
        navigate(`/apps/${id}/users`);
      }
    } catch (er) {
      console.error("failed to delete user :", er);
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchUserDetails();
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="w-full min-h-screen  xl-flex">
        <div className="flex-1 transition-all duration-300 ease-in-out lg:ml-[20px]">
          <div className=" mx-auto  max-w-(--breakpoint-2xl) md:p-4 md:py-4">
            <div className="min-h-screen ">
              <div className="grid grid-cols-1 lg:grid-cols-13 gap-6 ">
                {/* First section */}
                <div className="lg:sticky lg:top-4 lg:h-[calc(100vh-200px)] lg:overflow-y-auto lg:col-span-4">
                  <MyCard7
                    className={
                      "  px-4 py-6 h-fit lg:col-span-4 flex flex-col justify-center items-center"
                    }
                    children={
                      <>
                        <div className="w-20 h-20 rounded-full overflow-hidden border border-blue-500/70">
                          <img
                            // src="https://i.pravatar.cc/300"
                            src={data.image}
                            referrerPolicy="no-referrer"
                            alt="profile"
                            className="w-full h-full object-cover"
                            onClick={() => {
                              setPhoto(data.image);
                              setIsViewPhoto(true);
                            }}
                          />
                        </div>
                        <h2 className="text-sm font-semibold text-slate-800 dark:text-slate-200 mt-4">
                          {data.name}
                        </h2>
                        <div className=" flex  items-center justify-center space-x-2 mt-2">
                          <p className="text-xs font-normal font-monospace text-slate-500 dark:text-slate-400">
                            {data.uuid}
                          </p>
                          <Copy className="w-4 h-4 text-slate-500 dark:text-slate-400 font-normal cursor-pointer" />
                        </div>
                        <span className=" mt-4 text-[10px] text-slate-500 dark:text-slate-400">
                          {` Joined on ${data.doj}`}
                        </span>

                        {/* Invite Code */}
                        <MyCard2
                          className="p-2 mt-4"
                          title="Invite Code"
                          icon={User}
                          children={
                            <>
                              <div className="text-center flex space-x-2 items-center justify-start mt-2 ">
                                <span className="text-xs text-center font-semibold font-monospace text-slate-700 dark:text-slate-300">
                                  {data.refer_code}
                                </span>
                                <Copy
                                  onClick={() => {
                                    copyToClipboard(data.refer_code);
                                  }}
                                  className="w-4 h-4 text-slate-500 dark:text-slate-400   cursor-pointer"
                                />
                              </div>
                            </>
                          }
                        />
                        {/* Referral Code */}
                        <MyCard2
                          className="p-2 mt-4"
                          title="Referral Code"
                          icon={Users}
                          children={
                            <>
                              <div className="text-center flex space-x-2 items-center justify-start mt-2 ">
                                <span className="text-xs text-center font-semibold font-monospace text-slate-700 dark:text-slate-300">
                                  {data.referrer == ""
                                    ? "no referrer"
                                    : data.referrer}
                                </span>

                                <MyTooltip
                                  msg={[
                                    "That means this user can receive a referral bonus.",
                                    "",
                                  ]}
                                  tpId="0"
                                  icon={CircleCheckBig}
                                  color={"#35ee39"}
                                  border={1}
                                />
                              </div>
                            </>
                          }
                        />
                        <div className="grid grid-cols-2 gap-2 w-full mt-6">
                          {/* Coins card */}
                          <MyCard3
                            className="p-2 mt-4 w-full"
                            icon={Coins}
                            color={MyColors.green}
                            title={"Coins"}
                            value={data.coins}
                          />
                          {/* Offers card */}
                          <MyCard3
                            className="p-2 mt-4 w-full"
                            icon={Gift}
                            color={MyColors.purple}
                            title={"Offers"}
                            value={data.offers}
                          />
                          {/* Profile buttons */}
                        </div>
                        {/* View */}
                        <MyButton
                          className="mt-10 py-2"
                          title={"View Public Profile"}
                          color={MyColors.blue}
                          icon={Eye}
                          onClick={() => {
                            const url = id=="Mango Cash" ? `https://mangocash.in/user?token=${data.token}` : `https://app.pandaking.fun/user?token=${data.token}`;
                            window.open(url, "_blank");
                          }}
                        />
                        {/* sign out */}
                        <MyButton
                          className="mt-3 py-2"
                          title={isSignIn ? "Logout User" : "Signin User"}
                          color={MyColors.orange}
                          onClick={() => (isSignIn ? signOut() : signIn())}
                          icon={isSignIn ? LogOut : LogIn}
                        />
                        {/* delete account */}
                        <MyButton
                          className="mt-3 py-2"
                          title={isBlock ? "Unblock User" : "Block User"}
                          color={isBlock ? MyColors.green : MyColors.red}
                          onClick={() => (isBlock ? unblock() : block())}
                          icon={isBlock ? UserStar : UserX}
                        />
                      </>
                    }
                  />
                </div>
                {/* Section Section */}
                <div className="lg:col-span-9 space-y-4 ">
                  {/* General Detail */}
                  <MyCard7
                    className="  px-4 py-4  "
                    children={
                      <>
                        <div className="flex items-center justify-start ">
                          <User
                            className={`w-4 h-4 mr-2  ${MyColors.blue.text}`}
                          />
                          <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
                            General Detail
                          </span>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 w-full mt-4">
                          {/* email */}
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Email"
                            icon={Mail}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.email}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          {/* phone */}
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Phone Number"
                            icon={Phone}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.phone ? data.phone : "Not Available"}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          {/* telegram */}
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Telegram ID"
                            icon={TelegramLogo}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.telegram_id
                                      ? data.telegram_id
                                      : "Not Available"}
                                  </span>
                                </div>
                              </>
                            }
                          />
                        </div>
                      </>
                    }
                  />
                  {/* Payout Credentials */}
                  <MyCard7
                    className="  px-4 py-4  "
                    children={
                      <>
                        <div className="flex items-center justify-start ">
                          <CreditCard
                            className={`w-4 h-4 mr-2  ${MyColors.green.text}`}
                          />
                          <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
                            Payout Credentials
                          </span>
                          <button
                            onClick={() => freezeUserPayout(!isFreezed)}
                            className="text-orange-400 border border-slate-400 bg-slate-500/20 rounded-md px-1.5 py-1 font-medium space-x-1 flex items-center  mr-2 ml-auto"
                          >
                            {!isFreezed ? (
                              <RefreshCw size={14} />
                            ) : (
                              <Pause size={14} className="" />
                            )}
                            <span className="text-[11px]">
                              {!isFreezed ? "Unfreeze" : "Freeze"} Payouts
                            </span>
                          </button>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 w-full mt-4">
                          {/* Upi */}
                          <MyCard2
                            className="p-2 space-y-2"
                            title="UPI ID"
                            icon={CreditCard}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.upi ? data.upi : "Not Available"}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          {/* bank */}
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Bank (Acc.No@IFSC)"
                            icon={Landmark}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.bank_account_num && data.bank_ifsc
                                      ? `${data.bank_account_num}@${data.bank_ifsc}`
                                      : "Not Available"}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          {/* paypal */}
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Paypal ID"
                            icon={Wallet}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.paypal
                                      ? data.paypal
                                      : "Not Available"}
                                  </span>
                                </div>
                              </>
                            }
                          />
                        </div>
                      </>
                    }
                  />
                  {/* Invite */}
                  <MyCard7
                    className="  px-4 py-4  "
                    children={
                      <>
                        <div className="flex items-center justify-start ">
                          <Users
                            className={`w-4 h-4 mr-2  ${MyColors.purple.text}`}
                          />
                          <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
                            Invite
                          </span>
                        </div>

                        <div className="grid grid-cols-2 xl:grid-cols-4 gap-2 w-full mt-4">
                          <MyCard4
                            className="p-3"
                            icon={UserRoundPlus}
                            color={MyColors.green}
                            title={"Total"}
                            value={`${data.invites} / ${data.total_referral_signups}`}
                          />
                          <MyCard4
                            className="p-3"
                            icon={UserMinus}
                            color={MyColors.red}
                            title={"Reduction"}
                            onEdit={openReductionEdit}
                            value={invitesCutting}
                          />
                          <MyCard4
                            className="p-3"
                            icon={MousePointerClick}
                            color={MyColors.purple}
                            title={"Pointer"}
                            value={data.invites_current_buffer}
                          />
                          <MyCard4
                            className="p-3"
                            icon={Eye}
                            color={MyColors.orange}
                            title={"Visible"}
                            value={data.invites_visible}
                          />
                        </div>
                      </>
                    }
                  />
                  {/* Wallet */}
                  <MyCard7
                    className="  px-4 py-4  "
                    children={
                      <>
                        <div className="flex items-center justify-start ">
                          <Wallet
                            className={`w-4 h-4 mr-2  ${MyColors.green.text}`}
                          />
                          <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
                            Wallet
                          </span>
                          <button
                            onClick={() =>
                              navigate(`/apps/${id}/transactions/${user_id}`, {
                                state: { username: data.name },
                              })
                            }
                            className="text-blue-500    rounded-md px-1.5 py-1 font-medium space-x-1 flex items-center ml-auto mr-2"
                          >
                            <span className="text-[11px]">
                              View Transactions
                            </span>
                            <SquareArrowOutUpRight size={14} className="" />
                          </button>
                          <button
                            onClick={() => setOpenDebitModal(true)}
                            className="text-red-500 border border-slate-400 bg-slate-500/20 rounded-md px-1.5 py-1 font-medium space-x-1 flex items-center  mr-2"
                          >
                            <BanknoteArrowDown size={16} className="" />
                            <span className="text-[11px]">Debit</span>
                          </button>
                          <button
                            onClick={() => setOpenCreditModal(true)}
                            className="text-green-500 border  border-slate-400 bg-slate-500/20 rounded-md px-1.5 py-1 font-medium space-x-1 flex items-center "
                          >
                            <Gift size={16} className="" />
                            <span className="text-[11px]">Credit</span>
                          </button>
                        </div>

                        <div className="grid grid-cols-2 xl:grid-cols-4 gap-2 w-full mt-4">
                          <MyCard4
                            className="p-3"
                            icon={Coins}
                            color={MyColors.green}
                            title={"Total Earned"}
                            value={data.coins_in}
                          />
                          <MyCard4
                            className="p-3"
                            icon={UserMinus}
                            color={MyColors.red}
                            title={"Withdrawal"}
                            //  onEdit={() => {}}
                            value={data.coins_out}
                          />
                          <MyCard4
                            className="p-3"
                            icon={Handbag}
                            color={MyColors.gray}
                            title={"Refunded"}
                            value={data.coins_ref}
                          />
                          <MyCard4
                            className="p-3"
                            icon={Wallet}
                            color={MyColors.orange}
                            title={"Current Balance"}
                            value={data.coins}
                          />
                        </div>
                      </>
                    }
                  />
                  {/* Tracking Details */}
                  <MyCard7
                    className="  px-4 py-4 space-y-4 "
                    children={
                      <>
                        <div className="flex items-center justify-start ">
                          <ChartNoAxesCombined
                            className={`w-4 h-4 mr-2  ${MyColors.yellow.text}`}
                          />
                          <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
                            Tracking Details
                          </span>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full mt-4">
                          {/* wallet balance */}
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Google Advertisment Id"
                            icon={GoogleLogo}
                            color={MyColors.gray}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.gaid}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          {/* device id */}
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Device Id"
                            icon={DeviceMobileSpeaker}
                            color={MyColors.green}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.device_id}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="IP Address"
                            icon={GlobeStand}
                            color={MyColors.blue}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.ip}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Location"
                            icon={MapPinned}
                            color={MyColors.red}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.pincode +
                                      "," +
                                      data.state +
                                      ", " +
                                      data.country_code}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Device Name"
                            icon={DeviceMobileSpeaker}
                            color={MyColors.purple}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.device_brand}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Model Name"
                            icon={DeviceMobileSpeaker}
                            color={MyColors.purple}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.device_model}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="App Version"
                            icon={GitCommitVertical}
                            color={MyColors.green}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.app_version}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Android Version"
                            icon={AndroidLogo}
                            color={MyColors.green}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.android_version}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="UTM Source"
                            icon={Link}
                            color={MyColors.orange}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.device_utm_source}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="UTM Raw"
                            icon={Braces}
                            color={MyColors.red}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.utm_raw}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Kochava Attribution"
                            icon={Braces}
                            color={MyColors.blue}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center  rounded-lg bg-blue-500/20  px-2 font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.kochava == "1" ? "True" : "False"}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2"
                            title="Last Activity"
                            icon={Clock4}
                            color={MyColors.green}
                            children={
                              <>
                                <div className="flex flex-row">
                                  <span className="text-[11px] text-center   px-2 font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.last_activity}
                                  </span>
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2 "
                            title="Firebase Connection"
                            icon={CableOutlined}
                            color={MyColors.green}
                            children={
                              <>
                                <div className="flex flex-row items-center justify-start space-x-1">
                                  <span className="text-[11px] w-60 truncate text-center   px-2 font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.fcm_token}
                                  </span>
                                  <Copy
                                    onClick={() =>
                                      copyToClipboard(data.fcm_token)
                                    }
                                    className="w-4 h-4  cursor-pointer text-slate-500"
                                  />
                                </div>
                              </>
                            }
                          />
                          <MyCard2
                            className="p-2 space-y-2 "
                            title="Freefire ID"
                            icon={Flame}
                            color={MyColors.green}
                            children={
                              <>
                                <div className="flex flex-row items-center justify-start space-x-1">
                                  <span className="text-[11px] w-60 truncate text-start   px-2 font-medium font-monospace text-slate-700 dark:text-slate-300">
                                    {data.freefire_id != ""
                                      ? data.freefire_id
                                      : "Not Available"}
                                  </span>
                                </div>
                              </>
                            }
                          />
                        </div>
                      </>
                    }
                  />
                  {/* Dangerous */}
                  <MyCard7 className="  px-4 py-4 space-y-4 flex flex-col items-start justify-start ">
                    <div className="flex items-center justify-start ">
                      <MousePointer2Off
                        className={`w-4 h-4 mr-2  ${MyColors.orange.text}`}
                      />
                      <span className="text-sm font-medium font-sans text-slate-700 dark:text-slate-400">
                        Dengerous Actions
                      </span>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-4 md:grid-cols-2 items-start justify-start gap-4">
                      <button
                        onClick={() => setUserDeleteId(user_id)}
                        className="text-red-500 border border-slate-400 bg-slate-500/20 rounded-md px-1.5 py-1 font-medium space-x-1 flex items-center   ml-auto"
                      >
                        <Trash2 size={14} />

                        <span className="text-[11px]">Delete User</span>
                      </button>
                    </div>
                  </MyCard7>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MyModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Invite Reduction"
        width={"430px"}
      >
        <div className="mt-4">
          <span className="text-[12px] text-slate-600 font-light leading-[16px]">
            Set a threshold to skip a specified number of invites and count only
            every nth one. For example, with a reduction of 3, every fourth
            invite will be counted, while the first three are skipped.
          </span>

          <div className="flex flex-row items-center justify-start mt-4  space-x-2">
            <label
              htmlFor="invite-range"
              className="block text-sm font-normal text-slate-700 dark:text-slate-300"
            >
              {`Current Reduction : `}
            </label>
            <span className="text-green-500 text-sm">{inviteRed}</span>
          </div>

          <input
            id="default-range"
            type="range"
            value={inviteRed}
            min={0}
            max={100}
            step={1}
            onChange={(e) => {
              setInviteRed(Number(e.target.value));
            }}
            className="w-full h-2 bg-gray-400/50 rounded-full appearance-none cursor-pointer"
          />

          <div className="flex items-center justify-end gap-2 mt-4">
            <button
              onClick={() => setModalOpen(false)}
              className="px-3 py-1 rounded bg-slate-200 text-sm"
            >
              Cancel
            </button>
            <button
              onClick={saveReduction}
              className="px-3 py-1 rounded bg-blue-600 text-white text-sm"
            >
              Save
            </button>
          </div>
        </div>
      </MyModal>
      {/* Credit bonus */}
      <MyModal
        title={"Credit Bonus"}
        isOpen={isOpenCreditModal}
        onClose={() => {
          setOpenCreditModal(false);
          setBonusCoins(null);
          setMessage("");
          setErrors({});
        }}
        width="460px"
      >
        <div className="space-y-2 w-full flex flex-col">
          <p className="text-[12px] mt-2 font-semibold dark:text-slate-400 text-slate-600">
            You are about to add a bonus credit to this account. Choose/enter
            the amount and click confirm.
          </p>
          <span className="text-xs font-bold text-slate-800 dark:text-slate-50 mt-6">
            Choose bonus coins
          </span>

          <div className="flex items-center justify-start space-x-2 mt-2">
            {amtOptions.map((amt, index) => (
              <span
                onClick={() => {
                  setBonusCoins(amt);
                  if (errors.bonusCoins)
                    setErrors((prev) => ({ ...prev, bonusCoins: undefined }));
                }}
                key={index}
                className="text-xs font-normal font-mono text-green-600 dark:text-green-500 bg-slate-400/10 border-[0.5px] rounded-md px-2 py-1 border-green-600/30 cursor-pointer"
              >
                {"+" + amt}
              </span>
            ))}
          </div>
          <div className="mt-1">
            {/* Input */}
            <input
              type="number"
              placeholder="or enter custom amount."
              value={bonusCoins}
              min={1}
              onChange={(e) => {
                setBonusCoins(Number(e.target.value));
                if (errors.bonusCoins)
                  setErrors((prev) => ({ ...prev, bonusCoins: undefined }));
              }}
              className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
                ${
                  errors.bonusCoins
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }
                `}
            />
            {errors.bonusCoins && (
              <p className="text-xs text-red-500 font-semibold my-2">
                {errors.bonusCoins}
              </p>
            )}
          </div>
          {/* Message */}
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 dark:text-slate-200 mb-2">
              Message*
            </label>

            {/* Input */}
            <textarea
              type="text"
              placeholder="Enter a message,to show an transaction "
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
                if (errors.message)
                  setErrors((prev) => ({ ...prev, message: undefined }));
              }}
              className={`w-full h-20 text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
                 ${
                   errors.message
                     ? "border-red-400"
                     : "border-slate-200 dark:border-slate-700"
                 }
                `}
            />
            {errors.message && (
              <p className="text-xs text-red-500 font-semibold my-2">
                {errors.message}
              </p>
            )}
          </div>
          {/* action buttons */}
          <div className="flex space-x-4 justify-end mt-6">
            <BorderButton
              onClick={() => {
                setOpenCreditModal(false);
                setBonusCoins(null);
                setMessage("");
                setErrors({});
              }}
            >
              <span className="text-sm text-slate-400">Cancel</span>
            </BorderButton>
            <SolidButton
              //  disabled={isDisabled}
              className="px-4 py-2 text-sm space-x-2"
              onClick={(e) => creditBonus(e)}
            >
              {"Confirm"}
            </SolidButton>
          </div>
        </div>
      </MyModal>
      {/* Debit bonus */}
      <MyModal
        title={"Debit Bonus"}
        isOpen={isOpenDebitModal}
        onClose={() => {
          setOpenDebitModal(false);
          setBonusCoins(null);
          setMessage("");
          setErrors({});
        }}
        width="460px"
      >
        <div className="space-y-2 w-full flex flex-col">
          <p className="text-[12px] mt-2 font-semibold dark:text-slate-400 text-slate-600">
            You are about to cut a bonus to this account. Choose/enter the
            amount and click confirm.
          </p>
          <span className="text-xs font-bold text-slate-800 dark:text-slate-50 mt-6">
            Choose bonus coins
          </span>

          <div className="flex items-center justify-start space-x-2 mt-2">
            {amtOptions.map((amt, index) => (
              <span
                onClick={() => {
                  setBonusCoins(-amt);
                  if (errors.bonusCoins)
                    setErrors((prev) => ({ ...prev, bonusCoins: undefined }));
                }}
                key={index}
                className="text-xs font-normal font-mono text-red-600 dark:text-red-500 bg-slate-400/10 border-[0.5px] rounded-md px-2 py-1 border-red-600/30 cursor-pointer"
              >
                {"-" + amt}
              </span>
            ))}
          </div>
          <div className="mt-1">
            {/* Input */}
            <input
              type="number"
              placeholder="or enter custom amount."
              value={bonusCoins}
              max={-1}
              onChange={(e) => {
                setBonusCoins(-Math.abs(e.target.value));
                if (errors.bonusCoins)
                  setErrors((prev) => ({ ...prev, bonusCoins: undefined }));
              }}
              className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
                ${
                  errors.bonusCoins
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }
                `}
            />
            {errors.bonusCoins && (
              <p className="text-xs text-red-500 font-semibold my-2">
                {errors.bonusCoins}
              </p>
            )}
          </div>
          {/* Message */}
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 dark:text-slate-200 mb-2">
              Message*
            </label>

            {/* Input */}
            <textarea
              type="text"
              placeholder="Enter a message,to show an transaction "
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
                if (errors.message)
                  setErrors((prev) => ({ ...prev, message: undefined }));
              }}
              className={`w-full h-20 text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
                 ${
                   errors.message
                     ? "border-red-400"
                     : "border-slate-200 dark:border-slate-700"
                 }
                `}
            />
            {errors.message && (
              <p className="text-xs text-red-500 font-semibold my-2">
                {errors.message}
              </p>
            )}
          </div>
          {/* action buttons */}
          <div className="flex space-x-4 justify-end mt-6">
            <BorderButton
              onClick={() => {
                setOpenDebitModal(false);
                setBonusCoins(null);
                setMessage("");
                setErrors({});
              }}
            >
              <span className="text-sm text-slate-400">Cancel</span>
            </BorderButton>
            <SolidButton
              //  disabled={isDisabled}
              className="px-4 py-2 text-sm space-x-2"
              onClick={(e) => debitBonus(e)}
            >
              {"Confirm"}
            </SolidButton>
          </div>
        </div>
      </MyModal>
      {/* Priveiw Image */}
      <MyModal
        title={"Preview Image"}
        isOpen={isViewPhoto}
        onClose={() => {
          setIsViewPhoto(false);
        }}
        width="460px"
      >
        <div className="p-2 mt-2">
          <img
            src={photo}
            referrerPolicy="no-referrer"
            alt="profile"
            className="w-full  object-cover rounded-2xl"
          />
        </div>
      </MyModal>
      {/* DELETE User MODAL */}
      <MyModal
        isOpen={!!deleteUserId}
        title="Delete User?"
        onClose={() => setUserDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this User?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setUserDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={deleteUser} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}
